export const generateRandom2Digits = () => Math.trunc(Math.random().toFixed(2) * 100);
